export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    $('.skill-map-labels p').each(function(i) {
      var $p = $(this);
      setTimeout(function() {
        $p.addClass('display');
      }, i*300); // delay 300 ms
    });

    $('.skill-map-bars span').each(function(i) {
      var $bar = $(this);
      setTimeout(function() {
        $bar.css('width', $bar.attr('data-percentage') + '%');
      }, i*400); // delay 300 ms
    });

    var canclickmenuitem = true;
    $('.pms-account-navigation').bind('click touchstart', function () {
      if(window.innerWidth < 769) {
        if (canclickmenuitem) {
          canclickmenuitem = false;
          $(this).toggleClass('active').find('ul').toggleClass('active').slideToggle(300, function() {
            // Animation complete.
          });
        }
      }
    });

    $(window).resize(function(){
      if(window.innerWidth < 769) {
        if($('.pms-account-navigation').hasClass('active')) {
          $('.pms-account-navigation').removeClass('active');
          $('.pms-account-navigation').find('ul').removeClass('active').removeAttr('style');
          canclickmenuitem = true;
        }
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/myAccount.js